export const FLAG_GETTING_CREW_STATUSES = 'FLAG_GETTING_CREW_STATUSES';
export const GET_CREW_STATUSES = 'GET_CREW_STATUSES';
export const CLEAR_CREW_STATUSES = 'CLEAR_CREW_STATUSES';
export const FLAG_CREW_STATUS_ACTIVITY = 'FLAG_CREW_STATUS_ACTIVITY';
export const GET_CREW_STATUS = 'GET_CREW_STATUS';
export const CLEAR_CREW_STATUS = 'CLEAR_CREW_STATUS';
